import styled from 'styled-components'

export const Button = styled.button`
  position: relative;
  padding: 8px 12px;

  background: ${({ theme }) => theme.zds.colors.neutral1000};
  border: 1px solid ${props => props.theme.colors.colordfe3e8};
  border-radius: 4px;

  cursor: pointer;
  user-select: none;

  color: ${props => props.theme.colors.color545e6c};
  font-size: 12px;
  line-height: 14px;
  transition: all 0.4s;

  &:hover {
    color: ${props => props.theme.colors.color1f6ecd};
    border-color: ${props => props.theme.colors.color1f6ecd};
  }

  &:active {
    background: ${props => props.theme.colors.colore9ecf3};
  }

  &:focus-visible {
    color: ${props => props.theme.colors.color1f6ecd};
    border-color: ${props => props.theme.colors.color1f6ecd};
  }
`
